/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_ValidationInputs */

const fr_api_validation = /** @type {(inputs: Api_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez les valeurs saisies.`)
};

const en_api_validation = /** @type {(inputs: Api_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the entered values.`)
};

/**
* | output |
* | --- |
* | "Check the entered values." |
*
* @param {Api_ValidationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_validation = /** @type {((inputs?: Api_ValidationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_ValidationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_validation(inputs)
	return fr_api_validation(inputs)
});